import React, { useEffect } from "react";

import Banner from "components/common/Banner";
import TextBlock from "components/TextBlock";

import envs from "config/envs";

const OmbudsmanBanner = () => {
  useEffect(() => {
    document.title = "CNP Seguros Holding | Ouvidoria";
  }, []);

  return (
    <section role="banner">
      <Banner
        background={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_ombudsman_desktop.webp`}
        mobileBackground={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_ombudsman_mobile.webp`}
        className="make-section"
        data-section="banner ouvidoria section"
        width="100vw"
        height="49vw"
        isMobile
      >
        <Banner.Overlay isMobile>
          <TextBlock isPrimaryColor>Ouvidoria</TextBlock>
        </Banner.Overlay>
      </Banner>
      <Banner
        background={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_ombudsman_desktop.webp`}
        mobileBackground={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_ombudsman_mobile.webp`}
        className="make-section"
        data-section="banner ouvidoria section"
        width="100vw"
        height="25.7vw"
      >
        <Banner.Overlay>
          <TextBlock isPrimaryColor>Ouvidoria</TextBlock>
        </Banner.Overlay>
      </Banner>
    </section>
  );
};

export default OmbudsmanBanner;
